import { PayloadAction } from '@reduxjs/toolkit';
import createAppSlice from 'app/createAppSlice';
import { CreditScoreSliceType } from './types';

const initialState: CreditScoreSliceType = {
  scoreData: null,
  history: null,
};

const creditScoreSlice = createAppSlice({
  name: 'creditScore',
  initialState,
  reducers: {
    setCreditScoreData(
      state,
      action: PayloadAction<CreditScoreSliceType['scoreData']>,
    ) {
      state.scoreData = action.payload;
    },
    setCreditScoreHistory(
      state,
      action: PayloadAction<CreditScoreSliceType['history']>,
    ) {
      state.history = action.payload;
    },
  },
});

export const { setCreditScoreData, setCreditScoreHistory } =
  creditScoreSlice.actions;
export default creditScoreSlice.reducer;
